export enum StorePickerFilter {
    FILTER_EMPTY_STOCK = "filterEmptyStock",
}
